import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "access-control-systems-sydney";
const serviceId = 4;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Access Control Systems Sydney | Ozy Wide Group",
    description:
      "Card, fob, keypad and managed access systems that help control who can enter sensitive areas.",
    keywords:
      "access control Sydney, card access, fob access, keypad entry, biometric access, secure entry systems, access management",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Access Control Systems",
    description:
      "Card, fob, keypad and managed access systems that help control who can enter sensitive areas.",
    points: createServicePoints(
      "Access levels and users mapped",
      "Readers, locks and controls installed",
      "Permissions and reporting configured",
    ),
    images: createImageItems(images, "Access Control Systems Sydney"),
    content,
  };
